module.exports = __webpack_public_path__ + "img/card-frame-brown.2616bacf.png";